import { useEffect } from "react";
import { InvestmentCard } from "../../../components/Cards/InvestmentCard";
import { BottomNav } from "../../../components/Nav/BottomNav";
import { getUserInvestmentsRequest } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { BiLoaderAlt, BiWallet, BiPlus } from "react-icons/bi";

const Investment = () => {
  const dispatch = useDispatch();

  const {
    user,
    getUserInvestmentsError,
    investments,
    getUserInvestmentsLoading,
  } = useSelector((state) => {
    const {
      success: { claimInvestment: claimInvestmentSuccess },
      errors: {
        getUserInvestments: getUserInvestmentsError,
        claimInvestment: claimInvestmentError,
      },
    } = state.ajaxStatuses;

    const { getUserInvestmentsLoading, claimInvestmentLoading } =
      state.loadingIndicator;

    const { user, token } = state.userData;

    const { investments } = state.investmentData;

    return {
      user,
      getUserInvestmentsError,
      investments,
      getUserInvestmentsLoading,
      claimInvestmentSuccess,
      claimInvestmentError,
      claimInvestmentLoading,
      token,
    };
  });

  useEffect(() => {
    dispatch(getUserInvestmentsRequest(user._id));
  }, [getUserInvestmentsRequest]);

  useEffect(() => {
    if (getUserInvestmentsError) {
      toast.error(getUserInvestmentsError, {
        duration: 3000,
      });
    }
  }, [getUserInvestmentsError]);

  return (
    <div>
      <div
        className="min-h-screen w-full relative bg-slate-50 font-body selection:bg-blue-100 overflow-hidden pb-24 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/img/new/background/invesmentbg.jpeg')",
        }}
      >
        {/* --- Ambient Background "Glam" --- */}
        <div className="fixed top-0 left-0 w-[600px] h-[600px] bg-blue-200/40 rounded-full blur-[100px] pointer-events-none -translate-x-1/3 -translate-y-1/3 mix-blend-multiply z-0"></div>
        <div className="fixed bottom-0 right-0 w-[600px] h-[600px] bg-purple-200/40 rounded-full blur-[100px] pointer-events-none translate-x-1/3 translate-y-1/3 mix-blend-multiply z-0"></div>

        <div className="relative z-10 container px-6 py-8 w-full mx-auto h-full flex flex-col">
          {/* Header */}
          <div className="flex items-end justify-between mb-8">
            <div>
              <h2 className="font-head font-semibold text-xl text-white tracking-tight">
                <span className="inline-block border-b-4 border-blue-600 pb-1">
                  My
                </span>{" "}
                <span className="text-blue-600">Investments</span>
              </h2>
              <p className="text-sm text-blue-100 mt-2 font-medium">
                Track and grow your wealth with confidence
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-y-4">
            {getUserInvestmentsLoading ? (
              <div className="h-[40vh] flex flex-col items-center justify-center text-blue-600 gap-3">
                <BiLoaderAlt size={32} className="animate-spin" />
                <p className="text-xs font-medium uppercase tracking-widest text-slate-400">
                  Loading Assets...
                </p>
              </div>
            ) : (
              <>
                {investments.length === 0 ? (
                  // --- Restyled Empty State ---
                  <div className="flex flex-col items-center justify-center text-center py-12 bg-white/60 backdrop-blur-md border border-white/80 rounded-[2rem] shadow-sm px-6">
                    <div className="w-16 h-16 bg-blue-50 text-blue-400 rounded-full flex items-center justify-center mb-4">
                      <BiWallet size={32} />
                    </div>
                    <h3 className="font-head text-lg font-semibold text-slate-800 mb-2">
                      No Active Investments
                    </h3>
                    <p className="font-body text-slate-500 text-sm leading-relaxed">
                      You do not have an active plan yet. Fund your wallet and
                      start earning today.
                    </p>
                  </div>
                ) : (
                  investments.map(
                    (investment, index) =>
                      investment.isActive && (
                        <InvestmentCard investment={investment} key={index} />
                      ),
                  )
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div className="py-8 w-full mx-auto w-full ">
        <BottomNav />
      </div>
    </div>
  );
};

export default Investment;
